/**
 * Número que anda até o novo valor em vez de saltar.
 *
 * Num painel ao vivo, o salto seco não diz se subiu ou desceu — a transição
 * curta dá essa informação sem ocupar espaço. É deliberadamente rápida: 400 ms
 * informa, 2 s irrita quem olha o dia inteiro.
 */
import { useEffect, useRef, useState } from "react";

const DURATION_MS = 400;

export function AnimatedNumber({ value, className = "" }: { value: number; className?: string }) {
  const [display, setDisplay] = useState(value);
  const fromRef = useRef(value);
  const frameRef = useRef(0);

  useEffect(() => {
    const from = fromRef.current;
    if (from === value) return;
    const start = performance.now();

    function step(now: number): void {
      const progress = Math.min(1, (now - start) / DURATION_MS);
      // easeOutCubic: rápido no começo, assenta no fim.
      const eased = 1 - (1 - progress) ** 3;
      setDisplay(Math.round(from + (value - from) * eased));
      if (progress < 1) frameRef.current = requestAnimationFrame(step);
      else fromRef.current = value;
    }

    frameRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frameRef.current);
  }, [value]);

  return <span className={className}>{display}</span>;
}
